import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M2.5 10a.625.625 0 0 1 .625-.625h13.75a.625.625 0 1 1 0 1.25H3.125A.625.625 0 0 1 2.5 10"
	})
});
export default SvgMinus;
